import { z } from 'zod';

export const PAGE_SIZE = 25;

/** The page of open groups, kept in the URL; a group carries it to know its neighbours. */
export const duplicatesSearchSchema = z.object({
  page: z.coerce.number().int().min(1).default(1).catch(1),
});

export type DuplicatesSearch = z.output<typeof duplicatesSearchSchema>;
